import httpsV2 from '../../httpsV2'

export const getTenders = (limit, offset) => {
  return httpsV2.get(`/middleware/tenders?limit=${limit}&offset=${offset}`)
}

export const getAllTenders = () => {
  return httpsV2.get(`/middleware/tenders`)
}

export const getTender = (id) => {
  return httpsV2.get(`/middleware/tender/${id}`)
}

export const updateTender = (id, data) => {
  return httpsV2.patch(`/middleware/tender/${id}`, data)
}

export const getTenderChapters = (id) => {
  return httpsV2.get(`/middleware/tender/${id}/chapters`)
}

export const getTenderSubChapters = (id) => {
  return httpsV2.get(`/middleware/tender/chapter/${id}/subchapters`)
}

export const getTenderChapterPdf = (id) => {
  return httpsV2.get(`/middleware/tender/element/${id}/presigned-url`)
}

export const updateTenderChapterSupplierContacts = (id, data) => {
  return httpsV2.put(`/middleware/tender/element/${id}/supplier-contacts`, data)
}

export const notifyManufacturers = (id) => {
  return httpsV2.post(`/middleware/tender/${id}/notify-manufacturers`)
}

export const getSupplierToNPKbindings = () => {
  return httpsV2.get(`/middleware/tender/npk-to-supplier`)
}

export const obtainTenderOwnership = (id) => {
  return httpsV2.post(`/middleware/tender/${id}/obtain-ownership`)
}

export const getIncomingAttachmentsPresignedUrl = (id) => {
  return httpsV2.get(`/middleware/tender/incoming-attachments/${id}`)
}

export const inheritPreferencesToTender = (id, fromUser) => {
  return httpsV2.put(`/middleware/tender/${id}/inherit-prefereneces?fromUser=${fromUser}`)
}

export const clearAssignmentsOfChapter = (id) => {
  return httpsV2.delete(`/middleware/tender/chapter/${id}/assignments`)
}

